import type { TFunction } from "i18next";
import type { BusinessType } from "../types";

const DEFAULT_SUBTITLE_MARKERS = [
  "reservez votre table",
  "book your table",
  "reserva tu mesa",
  "ponte en cola para una mesa",
  "join the line for a table",
  "mettez-vous en file pour une table",
  "stellen sie sich fur einen tisch",
  "mettiti in fila per un tavolo",
  "entre na fila para uma mesa",
  "rejoignez la file chez",
  "prenez rendez-vous chez",
  "file d'attente atelier",
  "ponte en cola en",
  "join the line at",
];

const normalize = (value: string): string =>
  value
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase();

export const isPlatformDefaultSubtitle = (subtitle: string): boolean => {
  const normalized = normalize(subtitle);
  return DEFAULT_SUBTITLE_MARKERS.some((marker) => normalized.includes(marker));
};

export const resolveHomeSubtitle = (
  stored: string | undefined,
  businessType: BusinessType,
  orgName: string,
  t: TFunction,
  fallback: string,
): string => {
  if (!stored || isPlatformDefaultSubtitle(stored)) {
    const key = `business.${businessType}.homeSubtitle`;
    const translated = t(key, { name: orgName });
    if (translated && translated !== key) return translated;
    return fallback;
  }
  return stored;
};
